import React from 'react';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import './Blogs.scss';
import BlogCard from '../../../../components/BlogCard/BlogCard';
import BlogData from './BlogData';

const Blogs = () => {

    return (
        <section className='blog-section section-p'  data-aos="fade-up" data-aos-duration="1000">
            <div className="container">
                <SectionTitle
                    title="Rehabilitacja Medyczna - ulga w bólu"
                />
                <div className="offer-cards">
                    {
                        BlogData.map (blog => <BlogCard key={blog.title} {...blog} />)
                    }
                </div>
            </div>
        </section>
    );
};

export default Blogs;